customElements.define('component-menu-item', class MenuItem extends HTMLElement {
  constructor() {
    super();
    this.TEXT_TYPE = 'fitting_room';
    this.SECTION_IMAGE_HERO = 'section_image';
  }

  connectedCallback() {
    const template = document.getElementById('js-menu-item-template');
    this.appendChild(template.content.cloneNode(true));

    // Properties
    this.isFittingRoom = this.getAttribute('is-fitting-room') === 'true' || false;
    this.isComplementary = this.getAttribute('is-complementary-menu-option') === 'true' || false;
    this.title = this.getAttribute('title') || '';
    this.url = this.getAttribute('url') || '#';
    this.delay = this.getAttribute('delay') || 200;
    this.elementPosition = this.getAttribute('position') || 0;
    this.sectionImage = this.getAttribute('section-image') || '';
    this.showActive = this.getAttribute('show-active') === 'true' || false;
    this.showActiveIncludeSubmenus = this.getAttribute('show-active-include-submenus') === 'true' || false;
    this.isHighlighted = this.getAttribute('highlight') || false;
    this.contentColor = this.getAttribute('color') || '';
    this.backgroundColor = this.getAttribute('background') || '';
    this.subMenuDisabled = !!this.getAttribute('submenu-disabled') || false;
    this.key = this.normalizeKey(this.title.toLowerCase());

    // Fitting Room Properties
    if (this.isFittingRoom) {
      this.titleNot = this.getAttribute('title-not') || '';
      this.urlNot = this.getAttribute('url-not') || '#';
      this.ftrResultsUrl = localStorage.getItem('_tl_ftr_results_url');
      this.title = this.ftrResultsUrl ? this.title : this.titleNot;
      this.url = this.ftrResultsUrl ? this.ftrResultsUrl : this.urlNot;
      this.key = 'fitting-room';
    }

    this.mouseEnterTimer = undefined;
    this.mouseLeaveTimer = undefined;
    // In case the URL doesn't include de domain
    if (!(/^https?:\/\//ig).test(this.url)) {
      this.baseUrlSplit = window.location.host.split('.')
      this.baseUrlSplit.shift();
      this.baseUrl = this.baseUrlSplit.join('.');
      this.url = `https://www.${this.baseUrl}${this.url}`;
    }

    // Menu item sections
    this.itemSections = window.theme.menuSections ? window.theme.menuSections[this.key] : [];
    this.submenuItems = window.theme.menuSubItems ? window.theme.menuSubItems[this.key] : [];
    // DOM elements
    this.menuListItem = this.querySelector('.menu-item');
    this.menuLink = this.querySelector('.menu-link');
    this.subMenu = this.querySelector('.sub-menu');
    this.subMenuContainer = this.querySelector('.sub-menu-container');

    // Init
    this.menuListItem.setAttribute('data-attribute', this.key);
    this.menuLink.href = this.url;
    this.menuLink.innerHTML = this.title;
    this.menuLink.addEventListener('click', () => {
      this.trackGTM(this.title, this.url, this.elementPosition);
    });

    if (this.showActive) {
      let isActive = false;
      if (window.location.href.includes(this.url)) {
        isActive = true;
      }
      if (this.showActiveIncludeSubmenus && !isActive) {
        for (let item of this.submenuItems) {
          if (window.location.href.includes(item.url)) {
            isActive = true;
            break;
          }
          for (let subItem of item.subItems) {
            if (window.location.href.includes(subItem.url)) {
              isActive = true;
              break;
            }
          }
          if (isActive) break;
        }
      }
      if (isActive) {
        this.menuLink.classList.add('active-menu');
      }
    }

    if (this.isFittingRoom) {
      this.menuListItem.classList.add('ftr');
      this.menuLink.classList.add('ftr');
    }

    if (this.isComplementary) {
      this.menuListItem.classList.add('cmpl');
      this.menuLink.classList.add('cmpl');
    }

    // Set highlight
    if (this.isHighlighted) {
      this.menuLink.classList.add('highlight');
      this.menuLink.style.backgroundColor = this.backgroundColor || '#ffffff';
      this.menuLink.style.color = this.contentColor || '#2c272d';
    }

    // Set learn
    this.isLearnMenu = this.title.toLowerCase().includes('learn');
    if (this.isLearnMenu) {
      this.menuLink.classList.add('learn');
    }

    // Set kit
    this.isKitUndergarmentMenu = this.title.toLowerCase().includes('kit undergarments');
    if (this.isKitUndergarmentMenu) {
      this.menuLink.classList.add('kit');
      this.menuLink.innerHTML = '';
      this.menuLink.insertAdjacentHTML("beforeend", this.renderKitUndergarmentIcon());
    }

    // Render sections
    if (!this.subMenuDisabled) {
      this.renderSubmenu();
      this.renderSections();

      // Attach submenu display handler
      this.menuListItem.onmouseenter = this.mouseEnterHandler
      this.menuListItem.onmouseenter = this.menuListItem.onmouseenter.bind(this)
      this.menuListItem.onmouseleave = this.mouseLeaveHandler
      this.menuListItem.onmouseleave = this.menuListItem.onmouseleave.bind(this)
      this.subMenuContainer.onmouseenter = this.mouseEnterHandler
      this.subMenuContainer.onmouseenter = this.subMenuContainer.onmouseenter.bind(this)
      this.subMenuContainer.onmouseleave = this.mouseLeaveHandler
      this.subMenuContainer.onmouseleave = this.subMenuContainer.onmouseleave.bind(this)
    }
  }

  mouseEnterHandler() {
    clearTimeout(this.mouseLeaveTimer);
    this.mouseEnterTimer = setTimeout(() => { this.openSubMenu() }, this.delay);
  }

  mouseLeaveHandler() {
    clearTimeout(this.mouseEnterTimer);
    this.mouseLeaveTimer = setTimeout(() => { this.closeSubMenu() }, this.delay);
  }

  closeSubMenu() {
    if (this.menuIsOpen) {
      this.subMenuContainer.style.display = 'none';
      this.menuIsOpen = false;
    }
  }

  openSubMenu() {
    if (!this.menuIsOpen) {
      this.subMenuContainer.style.display = 'block';
      this.menuIsOpen = true;
    }
  }

  normalizeKey(key) {
    return key.replace(/[^\w&]/g, '-').toLowerCase();
  }

  renderLearnIcon() {
    const icon = `<svg
        width="16"
        height="17"
        viewBox="0 0 16 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect y="0.175781" width="16" height="16.5926" fill="none"></rect>
        <path
          d="M7.9997 13.8801V4.5358C6.18934 3.49439 4.35972 3.49438 2.89603 3.49438V4.5358M7.9997
          13.8801C7.28247 13.3318 5.88452 12.6465 2.89603 12.6998V4.5358M7.9997 13.8801H1.06641V4.5358H2.89603"
          stroke="#2C272D"
          stroke-linecap="round"
          stroke-linejoin="round"
        ></path>
        <path
          d="M8.27359 4.5358C10.0839 3.49439 11.6403 3.49438 13.104 3.49438V4.5358M13.104
          4.5358V12.6998C10.1155 12.6465 8.71753 13.3318 8.0003 13.8801H14.9336V4.5358H13.104Z"
          stroke="#2C272D"
          stroke-linecap="round"
          stroke-linejoin="round"
        ></path>
      </svg>`

     return icon;
  }

  renderKitUndergarmentIcon() {
    const icon = `<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 104.9 14" xml:space="preserve" width="105" height="14" role="img" aria-labelledby="kit-logo"><title id="kit-logo">Kit Undergarments</title><g><g><path d="M9.7,2.1c-0.7,0-1.5,0-2.2,0c0-0.2,0-0.4,0-0.6c0-0.4,0-0.8,0-1.1c0-0.2,0.1-0.2,0.2-0.2c0.6,0,1.2,0,1.8,0
    c0.1,0,0.2,0,0.2,0.2C9.7,0.9,9.7,1.4,9.7,2.1C9.7,2,9.7,2,9.7,2.1z"></path><path d="M2.9,7.9l-0.7,2.2V14H0V0.1h2.2v6.2h0.1l1.9-6.2h2.2L4.5,6.5l2,7.4H4.4L2.9,7.9z"></path><path d="M7.5,2.7h2.2V14H7.5V2.7z"></path><path d="M16.4,2h-1.8v12h-2.2V2h-1.8V0.1h5.7V2L16.4,2z"></path></g><g><path d="M24.6,0.1V11c0,0.6-0.1,1.1-0.3,1.5c-0.2,0.4-0.4,0.7-0.8,1c-0.4,0.3-0.9,0.5-1.5,0.5c-0.7,0-1.2-0.2-1.6-0.5
    c-0.4-0.3-0.6-0.6-0.8-1c-0.2-0.4-0.3-0.9-0.3-1.5V0.1h2V11c0,0.4,0.1,0.6,0.3,0.9c0.1,0.1,0.2,0.1,0.4,0.1c0.4,0,0.5-0.2,0.6-0.5
    c0.1-0.1,0.1-0.3,0.1-0.5V0.1H24.6z"></path><path d="M28,6.8l-0.2-0.6h-0.1v7.8h-1.8V0.1h1.8l2,7.2L29.8,8h0.1V0.1h1.8v13.8H30L28,6.8z"></path><path d="M33.2,13.9V0.1h1.6c1.9,0,2.9,0.4,3.4,1.4c0.5,1.1,0.6,2.8,0.6,5.5s-0.1,4.4-0.6,5.5c-0.5,1.1-1.5,1.4-3.4,1.4L33.2,13.9
    L33.2,13.9z M35.2,11.9c0.7,0,1.1-0.1,1.3-0.8c0.1-0.3,0.2-0.8,0.2-1.5c0-0.7,0-1.5,0-2.7s0-2,0-2.7c0-0.6-0.1-1.1-0.2-1.5
    c-0.2-0.7-0.6-0.7-1.3-0.7V11.9z"></path><path d="M40,0.1h4.3V2H42v4.1h2.3V8H42v4.1h2.3v1.8H40V0.1z"></path><path d="M49.1,13.9l-1-5.9h-0.5v5.9h-2V0.1h2c2.4,0,3.4,1.4,3.4,4c0,1.4-0.4,2.6-1.1,3.1l1.3,6.7H49.1L49.1,13.9z M47.6,6.2
    c0.3,0,0.6,0,0.9-0.3C48.8,5.7,49,5.1,49,4.2s-0.2-1.5-0.5-1.8c-0.3-0.3-0.7-0.3-0.9-0.3V6.2z"></path><path d="M55.4,5.1V3c0-0.4-0.1-0.6-0.3-0.9C55,2,54.9,2,54.7,2c-0.4,0-0.5,0.3-0.6,0.5C54,2.6,54,2.8,54,3v8.2
    c0,0.4,0.1,0.6,0.3,0.9c0.1,0.1,0.2,0.1,0.4,0.1c0.4,0,0.5-0.2,0.6-0.5c0.1-0.1,0.1-0.3,0.1-0.5V8.7h-0.8V7h2.8v6.8h-1.2l-0.2-0.6
    C55.6,13.6,55,14,54.4,14s-1.1-0.2-1.4-0.5c-0.3-0.3-0.6-0.6-0.7-1C52.1,12.1,52,11.6,52,11V3c0-0.5,0.1-1,0.3-1.5
    c0.2-0.4,0.4-0.7,0.8-1C53.5,0.2,54,0,54.7,0s1.2,0.2,1.5,0.5c0.4,0.3,0.6,0.6,0.8,1c0.2,0.4,0.3,0.9,0.3,1.5v2.1L55.4,5.1
    L55.4,5.1L55.4,5.1z"></path><path d="M58.2,13.9l2.1-13.8h2.5l2.1,13.8h-2l-0.4-2.8h-1.9l-0.4,2.8L58.2,13.9L58.2,13.9z M61.6,4.6l-0.1-0.4h-0.1l-0.1,0.4
    L60.8,9h1.4L61.6,4.6z"></path><path d="M69.2,14l-1-5.8h-0.5V14h-2V0.1h2c2.4,0,3.4,1.4,3.4,4c0,1.4-0.4,2.6-1.1,3.1l1.3,6.7L69.2,14L69.2,14z M67.6,6.3
    c0.3,0,0.6,0,0.9-0.3c0.3-0.3,0.5-0.8,0.5-1.7s-0.2-1.5-0.5-1.8s-0.7-0.3-0.9-0.3V6.3z"></path><path d="M75.5,13.9l-1.3-8.7l-0.1-0.6H74v9.2h-1.9V0.1h2.5l1.2,6.3l0.1,0.7h0L76,6.5l1.2-6.3h2.5v13.8h-1.9V4.7h-0.1l-0.1,0.6
    l-1.3,8.7L75.5,13.9L75.5,13.9z"></path><path d="M88.8,6.8l-0.2-0.6h-0.1v7.8h-1.8V0.1h1.8l2,7.2L90.6,8h0.1V0.1h1.8v13.8h-1.8L88.8,6.8z"></path><path d="M93.2,2.2V0.1H99v2.1h-1.9V14h-2V2.2L93.2,2.2L93.2,2.2z"></path><path d="M103,3.8c0-0.4,0-0.9-0.1-1.3c-0.1-0.4-0.3-0.6-0.6-0.6c-0.5,0-0.7,0.6-0.7,1.4c0,0.5,0.2,0.9,0.5,1.5
    c0.3,0.5,0.7,1.1,1.1,1.6c0.5,0.7,0.9,1.4,1.3,2.1s0.6,1.4,0.6,2.1c0,0.9-0.1,1.8-0.6,2.4s-1.1,1-2.2,1c-1.3,0-2-0.5-2.4-1.2
    S99.2,11,99.2,10l2-0.2c0,0.6,0,1.2,0.2,1.6c0.1,0.4,0.4,0.7,0.8,0.7c0.6,0,0.8-0.6,0.8-1.5c0-0.4-0.2-1-0.5-1.5
    c-0.2-0.3-0.3-0.5-0.5-0.8c-0.4-0.6-0.8-1.2-1.3-1.9c-0.4-0.7-0.8-1.4-1-2.1c-0.1-0.4-0.2-0.7-0.2-1.1c0-0.7,0.2-1.5,0.6-2.2
    c0.4-0.6,1.1-1,2-1c1.2,0,1.9,0.5,2.3,1.2c0.4,0.7,0.5,1.7,0.5,2.4L103,3.8z"></path><path d="M81.1,0.1h4.3V2h-2.3v4.1h2.3V8h-2.3v4.1h2.3v1.8h-4.3V0.1z"></path></g></g></svg>`;

    return icon;
  }

  renderSubmenu() {
    if (this.submenuItems && this.submenuItems.length) {
      const submenuComponent = this.createSubmenu(this.submenuItems);
      this.subMenu.appendChild(submenuComponent);
    }
  }

  renderSections() {
    if (this.itemSections && this.itemSections.length) {
      this.itemSections
        .filter((item) => item.type !== this.SECTION_IMAGE_HERO)
        .forEach((item) => {
          let cardEL;
          if (item.type === this.TEXT_TYPE) {
            cardEL = this.createTextCard(item);
          } else {
            cardEL = this.createImageCard(item);
          }
          this.subMenu.appendChild(cardEL);
        });
    }
  }

  createSubmenu(items) {
    const submenuComponent = document.createElement('component-menu-submenu');
    submenuComponent.items = items;
    return submenuComponent;
  }

  createTextCard(item) {
    const textComponent = document.createElement('component-card-text');
    textComponent.setAttribute("heading", item.heading);
    textComponent.setAttribute("sub-heading", item.subheading);
    textComponent.setAttribute("link", item.link);
    return textComponent;
  }

  createImageCard(item) {
    const imageComponent = document.createElement('component-card-image');
    imageComponent.setAttribute("heading", item.heading);
    imageComponent.setAttribute("link", item.link);
    imageComponent.setAttribute("image", item.image);
    imageComponent.setAttribute("imageAlt", item.imageAlt);
    imageComponent.setAttribute("ctaText", item.ctaText);
    if (item.headingCA) imageComponent.setAttribute("headingCA", item.headingCA);
    if (item.linkCA) imageComponent.setAttribute("linkCA", item.linkCA);
    if (item.imageCA) imageComponent.setAttribute("imageCA", item.imageCA);
    if (item.imageAltCA) imageComponent.setAttribute("imageAltCA", item.imageAltCA);
    if (item.ctaTextCA) imageComponent.setAttribute("ctaTextCA", item.ctaTextCA);
    return imageComponent;
  }

  trackGTM(title, url, elementPosition) {
    window.sendGTMData && window.sendGTMData({
      event: 'menu_nav_click',
      source: 'menu_nav',
      nav_bar_section_text: title,
      nav_bar_section_position: elementPosition,
      nav_bar_section_url: url
    });
  }
});



